export default "__VITE_ASSET__ydcXQqPd__"